export const colors = {
  gray_1_hover: '#d6d8df73',
  gray_1_active: '#d6d8dfc7',
  gray_2: '#dcdcdcad',
  gray_2_hover: '#dcdcdc',
  gray_3: '#9e9ea7',
  gray_4: '#515255',
  gray_4_hover: '#515255c2',
  gray_5_hover: '#eaeaea',
  gray_6: '#727272',
  red: '#f1554c',
  red_hover: '#e7483f',
  red_hover_2: '#f1554cb8',
  white_1: '#f7f9fa',
  white_1_hover: '#f4f3f3',
  red_2: '#FC9870',
  red_3: "#e12f52",
  orange: '#FFC972',
  purple: '#B692FE',
  purple_2: '#7d6fcd',
  blue: '#01D4FF',
  blue_2: '#4285f4',
  blue_2_hover: '#2a75f3',
  green: '#E4EE90',
  weakPassword: '#EC5840',
  mediumPassword: '#F7A61E',
  strongPassword: '#39C16C',
};

export const indexes = {
  backdrop: 20,
  nav: 10,
  palette: 5,
  note_btn: 5,
  poppedUI: 100,
  popover: 50,
  toast_btn: 1,
};

export const sizes = {
  sidebar_width: '90px',
};

export const transitions = {
  btnBgHover: 'background 100ms;',
};

export const shadows = {
  commonShadow:
    '0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%)',
};
